import React, { useEffect, useRef, useState } from "react";
import ReferenceMaterialUpload from './ReferenceMaterialUpload';
import Constants from "../../Constants";
import {  useTranslation } from 'react-i18next';
import Select from 'react-select';
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods';
import APIUrls from '../../services/APIUrls';
import { checkLanguageStatus, transformBlankToNull } from '../../services/Util';
import { useSelector,useDispatch } from 'react-redux'
import { updateSelectedTreeDataTargetLang, removeSelectedTreeDataTargetLang, addToSelectedTreeData,setSelectedTreeData, removeFromSelectedTreeData } from "../../redux/reducers/TreeSlice";
import {updateSourceLanguage } from '../../redux/reducers/CreateProjectSourceLanguageSlice';
import {updateTargetLanguage } from '../../redux/reducers/CreateProjectTargetLanguageSlice';
import $, { data } from "jquery";
import { dateConvertToTimeStamp } from "../../services/Util";
import { useParams} from 'react-router-dom';
import { handleError } from "../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from "../../ConditionalBlock";
import SuccessMessage from "../SuccessMessage";
import { SuccessTick,CrossIcon } from "../../AppIcons";
import TranslationMemorySelection from './TranslationMemorySelection';
import {updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';

export default function StaticAssets() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
    const dispatch = new useDispatch();
    const params = useParams()    
    const targetLanguageRedux = useSelector((reduxStore) => reduxStore.target_language_for_project_creation).value;
    const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
    const selectedTreeData = useSelector(reduxStore => reduxStore.tree_structure).selectedTreeData
    const oldTargetLanguage = useSelector(reduxStore => reduxStore.old_target_language)?.value
    const sourceLang = useSelector(reduxStore => reduxStore.source_language_for_project_creation).value;
    const contentTypeRedux = useSelector(reduxStore => reduxStore.content_type_for_project_creation).value
    const projectRequestIntegrationRedux = useSelector((redux) => redux.project_request_integration).value;
    const backgroundAssetUploadInfo = useSelector((redux) => redux.asset_upload_background).value;

	  const projectInfo = useSelector((reduxStore) => reduxStore.project_info).value;
    const [sourceLanguage, setSourceLanguage] =	useState([]);
    const [sourceLanguageOptions, setSourceLanguageOptions] =	useState([]);
	  const [targetLanguage, setTargetLanguage] =	useState([]);
    const [targetLanguageOptions, setTargetLanguageOptions] =	useState([]);
    const [allTargetLanguageCollection, setAllTargetLanguageCollection] = useState([]);
	  const [allSourceLanguageCollection, setAllSourceLanguageCollection] = useState([]);
	  const [selectedSourceLanguage, setSelectedSourceLanguage] = useState("");
	  const [selectedTargetLanguageList, setSelectedTargetLanguageList] = useState([]);
    const [isSourceLanguageLoading, setSourceLanguageLoading] = useState(true);
    const [isTargetLanguageLoading, setTargetLanguageLoading] = useState(true);
    const [hubsOptions, setHubsOptions] =	useState([]);
    const [streamOptions, setStreamOptions] =	useState([]);
    const [assetProjectData, setAssetProjectData] =	useState([]);
    const [tabOption,setTabOption] = useState("REFERENCE_MATERIAL");
    const [languageGroup,setLanguageGroup] = useState([]);
	  const [languageGroupValues,setLanguageGroupValues] = useState({});
    const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
    const projectAssetType = useSelector(redux => redux.asset_type_for_project_creation).value;
    const [inProgressProjectConfigs, setInProgressProjectConfigs] = useState([]);
    const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;
    function expandRightFunction() {
		  var element = document.getElementById("container");
		  element.classList.toggle("expand-right");
	  } 

    const iconComponent = () => {
      return (
        <i className="arrow-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.21967 0.815454C0.512563 0.519849 0.987437 0.519849 1.28033 0.815454L6 5.57882L10.7197 0.815454C11.0126 0.519849 11.4874 0.519849 11.7803 0.815454C12.0732 1.11106 12.0732 1.59033 11.7803 1.88593L6.53033 7.18455C6.23744 7.48015 5.76256 7.48015 5.46967 7.18455L0.21967 1.88593C-0.0732233 1.59033 -0.0732233 1.11106 0.21967 0.815454Z"
              fill="#076FA3"
            ></path>
          </svg>
        </i>
      );
    };

    const DepartmentProp = {
      PaperProps: {
        style: {
          fontSize: "85.71429%",
          color: aaaSelected ? "white" : "#1C233C",
          background: aaaSelected ? "black" : "#FFF",
        },
        arialabel: "list",
      },
    };

    const focusfirstElement = (e) => {
      if (e.target.nextSibling === null && e.key === "ArrowDown") {
        $(".MuiList-root").find("li").first().trigger("focus");
      }
      if (e.target.prevSibling === null) {
        $(".MuiList-root").find("li").last().trigger("focus");
      }
    };

    const addDepartmentSelectAttrb = (e) => {
      setTimeout(() => {
        $(".MuiList-root").find("li").first().css("opacity", 0);
        $(".MuiList-root").find("li").first().css("height", 0);
        $(".MuiList-root").find("li").first().css("padding", 0);
        $(".MuiList-root").attr("aria-label", "Delivery Status list");
      }, 200);
    };
  
    const stylesMonthSelect = {
    
    };

    useEffect(() => {
      getAxiosResponse(APIUrls.SOURCE_LANGUAGE)
        .then((res) => {
          setSourceLanguageLoading(false);
          if (res.data.code === 200) {
            const dbSourceLang = transformBlankToNull(res.data.data);
            setSourceLanguage(dbSourceLang);
            setAllSourceLanguageCollection(dbSourceLang);
            if(custBootstrapDataRedux?.roleSet?.customerProjectRequester)
            {
              dispatch(updateProjectInfo({}));
            }
            if(projectInfo.sourceLanguage && !custBootstrapDataRedux?.roleSet?.customerProjectRequester){
              setSelectedSourceLanguage(dbSourceLang.filter(lang=>projectInfo.sourceLanguage === lang.language)[0]);
            }
        }
        }).catch((err) => {
          handleError(err);
          setSourceLanguageLoading(false);
        });

      Promise.all([getAxiosResponse(APIUrls.TARGET_LANGUAGE),getAxiosResponse(APIUrls.GET_CUSTOMER_LANGUAGE_GROUP)])
      .then(([targetLangaugeResponse, languagePresetResponse])=>{
        setTargetLanguageLoading(false);
        const data = languagePresetResponse.data.data
        let langGrp = [{label:"-- Select Preset Group --",value:"",language:""}];
        if(data){
          let values = {};
          data.forEach((o)=>{
            values[o?.resource?.name] = o.displayName[0];
            langGrp.unshift({label:o?.resource?.name,value:o?.resource?.name,isGroup:true,isSelected:false})
          });
          setLanguageGroupValues(values);
          setLanguageGroup(langGrp);
        }
        if (targetLangaugeResponse.data.code === 200) {
          const dbTargetLang = transformBlankToNull(targetLangaugeResponse.data.data);
          setTargetLanguage(dbTargetLang);
          setAllTargetLanguageCollection(dbTargetLang);
          let targetLangs=[];
          dispatch(updateTargetLanguage([])); 
          if(selectedTreeData && selectedTreeData?.length > 0 ){
            selectedTreeData.map((asset,assetIndex) => {
              if(asset?.language && asset.language.length > 0 && checkLanguageStatus(asset?.language)){
                asset.language?.map((lang) => {
                  let event={
                    label: lang,
                    value: dbTargetLang.filter(obj=>obj.language===lang)[0],
                  }
                   handleTargetLanguageChangeCustom(event,assetIndex,targetLangs);
                })
              }
            })
          }
        }
      }).catch((err)=>{
        handleError(err);
        setTargetLanguageLoading(false);
      });

      if (contentTypeRedux === Constants.UBERFLIP) {
        const dateTimestamp = dateConvertToTimeStamp();
        getAxiosResponse(APIUrls.UBERFLIP_FOLDERS(params.id) + `?limit=0&offset=0&_=${dateTimestamp}`
        ).then(res => {
          if (res.data.code === 200) {
            let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
            const options = [];
            assetList.map(a => {
              let option = {label: a.assetName + " - " + a.id, value: a.id, asset: a}
              options.push(option)
            });
            setHubsOptions(options)
          } 
        }).catch(err => {
          handleError(err)
        })
      }

      if(contentTypeRedux === Constants.ELOQUA && projectData?.id) {
        let urlString = APIUrls.CUSTOMER_PROJECT_ASSET_CONFIGURATION_IN_PROGRESS(projectData?.id);
        const dateTimestamp = dateConvertToTimeStamp();
        getAxiosResponse(urlString +`?type=${contentTypeRedux}&_=${dateTimestamp}`)
        .then((res) => {
           let selectedIds = selectedTreeData.map(item => item?.externalId).filter(Boolean);
          const filteredData = res.data.data.filter(item => selectedIds.includes(item.externalId));
          setInProgressProjectConfigs(filteredData);
          localStorage.setItem("inProgressProjectConfigs", JSON.stringify(filteredData));
        }).catch((err) => {
          handleError(err);
        });
      }

      if(params.id !== undefined) {
        getAxiosResponse(APIUrls.ASSET_CONFIG_BY_PROJECT_ID(params.id)).then(res=>{
        setAssetProjectData(res.data.data.body)
        }).catch(err=>{
          handleError(err)
        })
      }

    }, []);

    useEffect(()=>{
      if(selectedSourceLanguage === "" && !isSourceLanguageLoading){
        dispatch(updateSourceLanguage({}));	
      }else{
        dispatch(updateSourceLanguage(selectedSourceLanguage));
      }		
    },[selectedSourceLanguage]);

     useEffect(()=>{
        if(assetProjectData?.length > 0){
          const updatedSelectedTreeData = selectedTreeData?.map(treeData => {
            const updatedTargetLanguages = treeData.targetLanguages?.map(lang => {
              const matchingAssetProjectData = assetProjectData?.find(assetData => {
                return (
                  treeData.externalId === assetData?.externalId &&
                  assetData?.ubHubId !== "" &&
                  assetData?.ubStreamId !== "" &&
                  lang?.language === assetData?.language
                );
              });
          
              if (matchingAssetProjectData) {
                return {
                  ...lang,
                  ubHubId: matchingAssetProjectData?.ubHubId,
                  ubHubName: matchingAssetProjectData?.ubHubName,
                  ubStreamId:matchingAssetProjectData?.ubStreamId,
                  ubStreamName:matchingAssetProjectData?.ubStreamName
                };
              } else {
                return lang;
              }
            });
            return {
              ...treeData,
              targetLanguages: updatedTargetLanguages
            };
          });
        dispatch(setSelectedTreeData(updatedSelectedTreeData));
        }
     },[assetProjectData])
  
      useEffect(()=>{
        if (!isTargetLanguageLoading) {
          if(selectedTreeData && selectedTreeData.length > 0){
            let targetLang=selectedTreeData?.flatMap(data=>data?.targetLanguages).filter(Boolean);
            dispatch(updateTargetLanguage(targetLang));
          }
          let selectedTargs = selectedTargetLanguageList.map((lang) => lang?.code);
          setTargetLanguage(allTargetLanguageCollection.filter(lang => !selectedTargs.includes(lang.code) && selectedSourceLanguage?.code !== lang.code));
          setSourceLanguage(allSourceLanguageCollection.filter(lang => !selectedTargs.includes(lang.code) && selectedSourceLanguage?.code !== lang.code));
        }		 
      },[selectedTargetLanguageList]);

      useEffect(() => {
        var sourceLangOptions = [];
        sourceLanguage?.map((source) => {
            sourceLangOptions.push({
              label: source.display,
              value: source,
            });
        });
        setSourceLanguageOptions(sourceLangOptions);
    }, [sourceLanguage])

    useEffect(() => {
      if(selectedTreeData && selectedTreeData.length > 0){
        let targetLang=selectedTreeData?.flatMap(data=>data?.targetLanguages).filter(o=> o!=undefined);
        dispatch(updateTargetLanguage(targetLang));
      }
      const selectedLangCodes = targetLanguageRedux?.map(lang=>lang.code);
      var targetLangOptions = [{label:"--Select All--",value:{code:"select-all",language:""}}];
      targetLanguage?.map((target) => {
        if(!selectedLangCodes?.includes(target.code)){
          targetLangOptions.push({
            label: target.display,
            value: target,
          });
        }
      });
      if(targetLangOptions?.length>0){
          if(languageGroup.length>1){
            languageGroup.forEach((o)=>{
                targetLangOptions.unshift(o);
            });
          }
      }
      setTargetLanguageOptions(targetLangOptions);
    }, [targetLanguage])
  

    const handleSourceLanguageChange = (event) => {
      setSelectedSourceLanguage(event.value)
      setSourceLanguage(allSourceLanguageCollection.filter(lang => event.label !== lang?.display));
      setTargetLanguage(allTargetLanguageCollection.filter(lang => event.label !== lang?.display));
    };

    const clearSourceLanguage = (event) => {
      setSelectedSourceLanguage("");
      setSourceLanguage(allSourceLanguageCollection);
      setTargetLanguage(allTargetLanguageCollection);
    };
    const clearSourceLanguageOnKeydown = (event) => {
      if (event.key === Constants.ENTER) {
        clearSourceLanguage(event);
      }
    };

    const handleTargetLanguageChange = (event, index) => {
      if(event?.isGroup){
        let targetLangGroup = languageGroupValues[event.value];
        const updatedLanguageGroup = languageGroup.map((lg)=>{
          if(lg.label === event.value){
            lg.isSelected = true;
          }
          return lg;
        });
        setLanguageGroup(updatedLanguageGroup);
        if(targetLangGroup?.length){
          targetLangGroup.forEach((lang)=>{
            updateTargetLanugaueIntoSelectedLanguage(lang);
            dispatch(updateSelectedTreeDataTargetLang({index: index, language: lang}))
          })
        }
      }else{
        let targetLang = event.value;
        updateTargetLanugaueIntoSelectedLanguage(targetLang);
        dispatch(updateSelectedTreeDataTargetLang({index: index, language: targetLang}))
      }
    };

    const updateTargetLanugaueIntoSelectedLanguage = (targetLang)=>{
      let targetLangs =  JSON.parse(JSON.stringify(selectedTargetLanguageList));
      if (!targetLangs.includes(targetLang)) {
        targetLangs.push(targetLang)
      }
      setSelectedTargetLanguageList(targetLangs);
      let selectedTargs = selectedTargetLanguageList.map((lang) => lang.code);
		  selectedTargs.push(targetLang.code);
      let langs = allTargetLanguageCollection?.filter((lang) => {
        return targetLang.display !== lang.display && selectedSourceLanguage?.code !== lang.code
      })
      setTargetLanguage(langs);
      setSourceLanguage(allSourceLanguageCollection?.filter(lang => targetLang.display !== lang.display && !selectedTargs.includes(lang.code) && selectedSourceLanguage?.code !== lang.code))
    }

    const handleTargetLanguageChangeCustom = (event, index,targetLangs) => {
      let targetLang = event.value;
      if (!targetLangs.includes(targetLang)) {
        targetLangs.push(targetLang)
      }
      setSelectedTargetLanguageList(targetLangs);
      let selectedTargs = selectedTargetLanguageList.map((lang) => lang.code);
		  selectedTargs.push(event.value?.code);
      setTargetLanguage(allTargetLanguageCollection?.filter(lang => event.label !== lang.display && selectedSourceLanguage?.code !== lang.code));
      setSourceLanguage(allSourceLanguageCollection?.filter(lang => event.label !== lang.display && !selectedTargs.includes(lang.code) && selectedSourceLanguage?.code !== lang.code))
      dispatch(updateSelectedTreeDataTargetLang({index: index, language: targetLang}))
    };

    const clearTargetLanguage = (event, index, langIndex, targetLang) => {
      Object.keys(languageGroupValues).forEach((key,val)=>{
        let updatedGrps = languageGroup.map(grp=>{
          if(key === grp.label){
            let array = languageGroupValues[key].map(o=>o.code);
            if(array.includes(targetLang.code)){
              grp.isSelected = false;
            }
          }
          return grp;
        })
        setLanguageGroup(updatedGrps);
      });
      setSelectedTargetLanguageList(selectedTargetLanguageList.filter(lang => lang.code !== targetLang.code));
      dispatch(removeSelectedTreeDataTargetLang({index: index, langIndex: langIndex, language: targetLang}))
    }

    const clearTargetLanguageOnKeydown = (event, index, langIndex, targetLang) => {
      if(event.key === Constants.ENTER) {
        clearTargetLanguage(event, index, langIndex, targetLang)
      }
    }

    const getIntegrationName = () => {
      let integrationName;
      if (contentTypeRedux === Constants.MARKETOREST) {
        integrationName = Constants.MARKETO_CONTENT_TYPE_DISPLAY
      } else if (contentTypeRedux === Constants.ELOQUA) {
        integrationName = Constants.ELOQUA_CONTENT_TYPE_DISPLAY
      } else if (contentTypeRedux === Constants.BRIGHTCOVE) {
        integrationName = Constants.BRIGHTCOVE_CONTENT_TYPE_DISPLAY
      } else if (contentTypeRedux === Constants.PARDOT) {
        integrationName = Constants.PARDOT_CONTENT_TYPE_DISPLAY
      } else if (contentTypeRedux === Constants.VIDYARD) {
        integrationName = Constants.VIDYARD_CONTENT_TYPE_DISPLAY
      } else if (contentTypeRedux === Constants.UBERFLIP) {
        integrationName = Constants.UBERFLIP_CONTENT_TYPE_DISPLAY
      }
      return integrationName;
   }

    const handleUberflipHubsChange = (event, index, langIndex, lang) => {
      let hubId = event.value;
      let asset = event.asset;
      let selectedAsset = JSON.parse(JSON.stringify(selectedTreeData[index]));
      let targetLang = selectedAsset.targetLanguages[langIndex];
      if (targetLang?.code === lang?.code) {
        targetLang.ubHubId = asset.id;
        targetLang.ubHubName = asset.assetName;
      }
      dispatch(addToSelectedTreeData(selectedAsset));
      getSelectedHubStream(hubId);
    }

    const getSelectedHubStream = (hubId) => {
      const dateTimestamp = dateConvertToTimeStamp();
        getAxiosResponse(
          APIUrls.UBERFLIP_FOLDER_CHILDREN(params.id, hubId) + `?limit=0&offset=0&_=${dateTimestamp}`
        ).then(res => {
            if (res.data.code === 200) {
              let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
              const options = [];
              assetList.map(a => {
                let option = {label: a.assetName, value: a.id, asset: a}
                options.push(option);
              });
              setStreamOptions(options)
            }
        }).catch(err => {
          handleError(err);
        });
    }

    const handleUberflipStreamChange = (event, index, langIndex, lang) => {
      let asset = event.asset;
      let selectedAsset = JSON.parse(JSON.stringify(selectedTreeData[index]));
      let targetLang = selectedAsset.targetLanguages[langIndex];
      if (targetLang?.code === lang?.code) {
        targetLang.ubStreamId = asset.id;
        targetLang.ubStreamName = asset.assetName;
      }
      //dispatch(removeFromSelectedTreeData(selectedAsset))
      dispatch(addToSelectedTreeData(selectedAsset));
    }

    const convertAssets = (assetTypeResponseList) => {
      let assets = transformBlankToNull(assetTypeResponseList)
      let assetList = [];
      assets?.map(asset => {
        asset.assetList.map(a => {
          a.assetType = asset.assetType;
          a.id = a.assetId;
          assetList.push(a)
        });
      })
      return assetList;
    }

    function renderValidationErrors() {
      return (
          backgroundAssetUploadInfo.validationErrors && backgroundAssetUploadInfo.validationErrors.map((validation, index) => (
              <div className="flex" key={index}>
                  {index + 1}.&nbsp;<strong>{validation.name}</strong>&nbsp;:&nbsp;
                  {validation.error !== "" ? <p className={contentTypeRedux !== Constants.ELOQUA ? "error-alert" : "warning"}>{validation.error}</p> : SuccessTick}
              </div>
          ))
      );
    }

    const checkLanguageFadeOrNot=(asset,lang)=>{
      if(contentTypeRedux === Constants.ELOQUA && projectData?.clonedFromProjectId === null && projectAssetType !== Constants.DYNAMIC)
      {
        if (treeValueRedux?.assetInTranslation?.length > 0) {
            if (asset && asset?.externalId) {
              const externalId = asset?.externalId;
              for (let i = 0; i < treeValueRedux?.assetInTranslation.length; i++) {
                const assetId = treeValueRedux?.assetInTranslation[i];
                for (let key in assetId) {
                  if (key.endsWith(externalId) && assetId[key].some(item => item?.language === lang?.language)) {
                    return true;
                  }
                }
              }
            }
          };
         const isLanguageMatched = inProgressProjectConfigs.some(data => data?.language === lang?.language && data?.externalId === asset?.externalId);
        return isLanguageMatched;
      }
      else{
        let status=false
        oldTargetLanguage.forEach(data=>{
            if(data?.externalId===asset?.externalId && data?.language?.includes(lang?.language) && projectAssetType !== Constants.DYNAMIC){
             status=true
            }        
        })  
        return status 
      } 
  }


  return (
    <div>
      <div className="source-and-target-block">
      <h3>{translate("other_integrations_project_creation.source_materials")} {projectRequestIntegrationRedux.contentName || getIntegrationName()}</h3>
      <div className="lang-selection-block left-label">
          <h5 className="heading-width-border">{translate("other_integrations_project_creation.language_selection")}</h5>
          <div className="flex wrap-dropdown space-gap">
              <div className="global-dropdown-block flex m-0">
                  <label>{translate("other_integrations_project_creation.source_language")}</label>
                  <div className="global-dropdown-select">				   
                    <Select menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix='cw'
                        IconComponent={iconComponent}
                        autoFocus={true}
                        value={selectedSourceLanguage}
                        onChange={event => handleSourceLanguageChange(event)}
                        onOpen={event => addDepartmentSelectAttrb(event)}
                        renderValue={(selected) =>  "Select Source Language"}
                        displayEmpty
                        MenuProps={ DepartmentProp }
                        style={stylesMonthSelect}
                        className={selectedSourceLanguage ===''? '':'after-selection'}
                        options={sourceLanguageOptions}
                    />
                  </div>
                  <div className="multiselect-output flex">
                    {selectedSourceLanguage && <button onClick={(e)=>clearSourceLanguage(e)} onKeyDown={(e)=>clearSourceLanguageOnKeydown(e)}>
                      <strong>{selectedSourceLanguage.display}</strong>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                          <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                      </button>}
                    </div>
                  </div>
              <div className="cust-arrow mr-0 ml-0"></div>              
              <div className="global-dropdown-block flex-center">
                  <label>{translate("other_integrations_project_creation.select_target_language")} </label>
                  <div className="global-dropdown-select">
                  <Select
                    menuShouldScrollIntoView={false}
                    closeMenuOnSelect={true}
                    classNamePrefix='cw'
                    IconComponent={iconComponent}
                    autoFocus={true}
                    value={selectedSourceLanguage}
                    onChange={event => handleTargetLanguageChange(event, -1)}
                    onOpen={event => addDepartmentSelectAttrb(event)}
                    renderValue={(selected) => "Select Target Language"}
                    displayEmpty
                    MenuProps={ DepartmentProp }
                    style={stylesMonthSelect}
                    className={selectedSourceLanguage ===''? '':'after-selection'}
                    options={targetLanguageOptions}
                  />
                  </div>
              </div>
          </div>
      </div>
      <div className="target-selection-block conditional-target-selection show">
          <div className="addextra-target-lang">
              <div className="w-d100 inline-dropdown">
                  <div className="flex mar-bot30">
                    {selectedTreeData?.map((selectedAsset, index) => {
                      return (
                        selectedAsset?.assetType !== Constants.IMAGE &&
                        <div className="global-dropdown-block flex mb-0">
                        <label>{selectedAsset?.name?.length > 0 ? selectedAsset.name : selectedAsset?.assetName}</label>
                        <div className="m-w100">
                          <small>Add +</small>
                          <div className="global-dropdown-select mar-bot16">
                          <Select
                            menuShouldScrollIntoView={false}
                            closeMenuOnSelect={true}
                            classNamePrefix='cw'
                            IconComponent={iconComponent}
                            autoFocus={true}
                            value={selectedSourceLanguage}
                            onChange={event => handleTargetLanguageChange(event, index)}
                            onOpen={event => addDepartmentSelectAttrb(event)}
                            renderValue={(selected) => "Select Target Language"}
                            displayEmpty
                            MenuProps={ DepartmentProp }
                            style={stylesMonthSelect}
                            className={selectedSourceLanguage ===''? '':'after-selection'}
                            options={targetLanguageOptions}
                          />
                          </div>
                          <div className={contentTypeRedux === Constants.UBERFLIP ? "multiselect-output flex flex-column" : "multiselect-output flex"}>
                          {selectedAsset.targetLanguages?.map((lang, langIndex) => {
                            return (contentTypeRedux === Constants.UBERFLIP
                              ?
                              <>
                              <div key={langIndex} className="flex-center mar-bot16 btn-gap">
                              <button onClick={(e)=>clearTargetLanguage(e, index, langIndex, lang)} onKeyDown={(e)=>clearTargetLanguageOnKeydown(e, index, langIndex, lang)}>
                              <strong>{lang.display}</strong>
                              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                              </button>
                              <div className="global-dropdown-select">
                                <Select
                                  menuShouldScrollIntoView={false}
                                  closeMenuOnSelect={true}
                                  classNamePrefix='cw'
                                  IconComponent={iconComponent}
                                  autoFocus={true}
                                  value={{label: lang.ubHubName === undefined ? "Select Hubs" : (lang.ubHubName + " - " + lang.ubHubId), value: lang.ubHubId}}
                                  onChange={event => handleUberflipHubsChange(event, index, langIndex, lang)}
                                  onOpen={event => addDepartmentSelectAttrb(event)}
                                  renderValue={(selected) => "Select Hubs"}
                                  MenuProps={ DepartmentProp }
                                  style={stylesMonthSelect}
                                  options={hubsOptions}
                                />
                              </div>
                              <div className="global-dropdown-select">
                                <Select
                                  menuShouldScrollIntoView={false}
                                  closeMenuOnSelect={true}
                                  classNamePrefix='cw'
                                  IconComponent={iconComponent}
                                  autoFocus={true}
                                  value={{label: lang.ubStreamName === undefined ? "Select Stream" : lang.ubStreamName, value: lang.ubStreamId}}
                                  onChange={event => handleUberflipStreamChange(event, index, langIndex, lang)}
                                  onOpen={event => addDepartmentSelectAttrb(event)}
                                  renderValue={(selected) => "Select Stream"}
                                  MenuProps={ DepartmentProp }
                                  style={stylesMonthSelect}
                                  options={streamOptions}
                                />
                              </div>
                              </div>
                              </>
                              :
                                <button className={checkLanguageFadeOrNot(selectedAsset,lang)?"fadeLanguage":Constants.BLANK} key={langIndex} onClick={(e)=>clearTargetLanguage(e, index, langIndex, lang)} onKeyDown={(e)=>clearTargetLanguageOnKeydown(e, index, langIndex, lang)}>
                                  <strong>{lang?.display}</strong>
                                  {CrossIcon}
                                </button>
                              )
                             
                          })}
                          </div>
                      </div>
                  </div>)
                    })}
                      
                  </div>
                  {renderValidationErrors()}
              </div>
          </div>
      </div>      
      {!projectRequestIntegrationRedux.isProjectRequest &&
        <div className="materials-tab">
            <h5 className="heading-width-border">{translate("other_integrations_project_creation.reference_materials")}</h5>
            <div className="listing-tab-block flex">
                <ul className="listing-tab-link flex" role="tablist">
                <li role="none">
                  <button 
                     className={tabOption === "REFERENCE_MATERIAL" ? "active" : ""} onClick={()=>setTabOption("REFERENCE_MATERIAL")}
                     role="tab"
                     aria-label={translate("other_integrations_project_creation.reference_materials")}
                     aria-selected="true"                     >
                    {translate("other_integrations_project_creation.reference_materials")}
                  </button>
                  </li>
                  <li role="none">
                  <button
                     className={tabOption === "TRANSLATION_MATERIAL" ? "active" : ""} onClick={()=>setTabOption("TRANSLATION_MATERIAL")}
                     role="tab"
                     aria-label="Translation Materials"
                     aria-selected="true"                     >
                    Translation Materials
                  </button>
                  </li>
                </ul>
            </div>
            <div className={tabOption === "REFERENCE_MATERIAL" ? "materials-tab-content flex" : "materials-tab-content flex hide"}>
						<ReferenceMaterialUpload/>
					</div>
            <div className={tabOption === "TRANSLATION_MATERIAL" ? "materials-tab-content flex" : "materials-tab-content flex hide"}>
						<TranslationMemorySelection projectId={projectInfo.id}/>
					</div>
        </div>
      }
      </div>
    </div>
  );
}
